<!-- 水果行情 -->
<template>
  <div class="site-content" style="position: relative;">
    <div class="site-content-page" v-if="info">
      <div class="content-row">
        <ul class="list-tab-ul-1" v-if="tabList.length>0">
          <li style="padding:0;margin:0;" v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.type==type ?'li-active' : '']"
              v-on:click="selectedAct(tab.type)">{{ tab.title }}
          </li>
        </ul>
      </div>
      <p class="page-title">{{ info.spec.name }}</p>
      <div v-if="chinaSale" style="line-height: 50px;font-size: 18px;color:#FF5C00;">{{chinaSale.message}}</div>
      <div class="page-block">
        <div class="item">
          <p class="label">日期</p>
          <span class="value">{{ info.date_time }}</span>
        </div>
        <div class="item">
          <p class="label">{{ info.type == 1 ? '产地' : '市场' }}</p>
          <span class="value">{{ info.dependency }}</span>
        </div>
        <div class="item" v-if="info.country">
          <p class="label">国别</p>
          <span class="value">{{ info.country }}</span>
        </div>
        <div class="item">
          <p class="label">今日价格</p>
          <span class="value red b">{{ info.today_price }}</span>
        </div>
        <div class="item">
          <p class="label">昨日价格</p>
          <span class="value green b">{{ info.yesterday_price }}</span>
        </div>
        <div class="item">
          <p class="label">较昨日</p>
          <template v-if="info.daily_change<0">
            <span class="value b red">{{ info.daily_change }}% ↓</span>
          </template>
          <template v-else>
            <span class="value b green">{{ info.daily_change }}% ↑</span>
          </template>

        </div>

      </div>
      <!--      日期筛选-->
      <div class="echart-params">
        <div class="item" @click="handlePrev">上一月</div>
        <div class="item" @click="handleNow" :class="[isEnd?'dis':'']">本月</div>
        <div class="item" @click="handleNext" :class="[isEnd?'dis':'']">下一月</div>
      </div>
      <div class="line-echart-box">
        <div class="title">{{ date(startDate, 'yyyy年MM月dd日') }} - {{ date(endDate, 'yyyy年MM月dd日') }}</div>
        <div class="line-echart" id="avocadoEcharts"></div>
        <div class="mask-loading" v-if="echartLoading"><img src="../../assets/loading.png" class="loading"/></div>
      </div>
      <template v-if="pageInfo.list.length>0">
        <p class="page-title2 mt-20">其他{{ type == 1 ? '产地' : '市场' }}对比</p>
        <div class="content-col mt-20">
          <AvocadoPriceDataList class="mt-20" :loading="moreLoading" :type="type" :page-info="pageInfo"
                                @pageChange="queryMorePage" @itemClick="handlePriceMoreClick"></AvocadoPriceDataList>
        </div>
      </template>

    </div>
    <div class="mask-loading" v-if="loading"><img src="../../assets/loading.png" class="loading"/></div>
    <div class="mt-20"></div>
  </div>
</template>

<script>
import InfoPageList05 from '../block/InfoPageList05'
import AvocadoPriceDataList from '../block/AvocadoPriceDataList.vue'
import {date} from '../utils/utils'
import {GridComponent} from 'echarts/components'

let echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/line')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legend')

echarts.use([GridComponent])

export default {
  name: 'Sghq01',
  components: {
    'infoPageList-05': InfoPageList05,
    'AvocadoPriceDataList': AvocadoPriceDataList
  },
  data() {
    return {
      id: 0,
      tabList: [{title: '产地价格', type: '1'}, {title: '市场价格', type: '2'}],
      type: 1,
      info: undefined,
      echart: undefined,
      startDate: '',
      endDate: '',
      loading: false,
      echartLoading: false,
      moreLoading: false,
      params: {},
      pageInfo: {
        list: [],
        page: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      },
      chinaSale:null
    }
  },
  computed: {
    // 判断是否有下一月的参数 结束时间>=当前时间
    isEnd() {
      return date(this.endDate, 'yyyy-MM-dd') === date(new Date(), 'yyyy-MM-dd')
    }
  },
  created: function () {
    this.id = this.$route.params.id
    this.pageLoad()
  },
  methods: {
    date: date,
    selectedAct(id) {
      this.$router.push({name: 'jghq', query: {type: id}})
    },
    pageLoad() {
      const dd = new Date()
      this.startDate = date(new Date((dd.setDate(dd.getDate() - 30))), 'yyyy-MM-dd')
      this.endDate = date(new Date(), 'yyyy-MM-dd')
      this.fetchData()
    },
    handleNow() {
      const dd = new Date()
      this.startDate = date(new Date((dd.setDate(dd.getDate() - 30))), 'yyyy-MM-dd')
      this.endDate = date(new Date(), 'yyyy-MM-dd')
      this.fetchChartData()
    },
    // 上一个月
    handlePrev() {
      const dd = new Date(this.startDate)
      const start = this.startDate
      this.startDate = date(new Date((dd.setDate(dd.getDate() - 30))), 'yyyy-MM-dd')
      this.endDate = start
      this.fetchChartData()
    },
    // 下一个月
    handleNext() {
      if (this.isEnd) {
        return
      }
      const end = this.endDate
      this.startDate = end
      const dd = new Date(this.endDate)
      const endTime = new Date(dd.setDate(dd.getDate() + 30))
      this.endDate = date(endTime, 'yyyy-MM-dd')
      this.fetchChartData()
    },
    queryMorePage(e) {
      this.pageInfo.page.page = e.page
      this.pageInfo.page.pageSize = e.pageSize
      this.fetchMoreData()
    },
    handlePriceMoreClick(item) {
      this.id = item.id
      this.pageLoad()
    },
    fetchMoreData() {
      this.moreLoading = true
      this.$dataApi.getAvocadoPriceDataList({
        ...this.params,
        ...this.pageInfo.page
      }).then(res => {
        if (res.code !== 1) {
          this.moreLoading = false
          return
        }
        const {data} = res
        this.pageInfo.list = data.list
        this.pageInfo.page.page = data.page
        this.pageInfo.page.total = data.total
        this.moreLoading = false
      })
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$dataApi.getPriceData({
          id: this.id,
          timeType: 'range',
          startDate: this.startDate,
          endDate: this.endDate
        }).then(({data, code, msg}) => {
          if (code !== 1) {
            this.loading = false
            reject(msg)
          }
          console.log(data)
          const {info, chartData} = data
          this.type = info.type
          this.info = info

          if (Number(this.type)===1) {
            this.fetchConfig()
          } else {
            this.chinaSale = null
          }
          // 查询更多
          this.params = {
            moreId: info.id,
            type: info.type,
            specId: info.spec.id
            // date: info.date_time
          }
          this.fetchMoreData()

          this.$nextTick(() => {
            this.initEcharts(chartData.xAxis, chartData.yAxis)
            this.loading = false
          })
        })
      })
    },
    fetchConfig: function () {
      this.$dataApi.getAvocadoConfig({}).then((res) => {
        if (res.code !== 1) {
          this.chinaSale = null
          return
        }
        const sale = (res.data.find(x => x.key === 'sale') || {value: '1'}).value || '1'
        const message = (res.data.find(x => x.key === 'over_message') || {value: ''}).value || ''

        this.chinaSale = {
          sale,
          message
        }
      })
    },
    fetchChartData() {
      this.echartLoading = true
      return this.$dataApi.getPriceData({
        id: this.id,
        timeType: 'range',
        startDate: this.startDate,
        endDate: this.endDate
      }).then(({data, code, msg}) => {
        if (code !== 1) {
          this.echartLoading = false
        }
        this.$nextTick(() => {
          this.initEcharts(data.chartData.xAxis, data.chartData.yAxis)
          this.echartLoading = false
        })
      })
    },
    initEcharts(xAxis, yAxis) {
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let str = ''
            params.forEach(item => {
              str += item.name + '<br />' + (item.value).toFixed(2) + '</br>'
            })
            return str
          }
        },
        xAxis: {
          type: 'category',
          data: xAxis,
          axisLabel: {
            rotate: 60 // 倾斜角度
          }
        },
        yAxis: {
          name: this.info ? '元/' + (this.info.unit) : '',
          type: 'value'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '15%'
        },
        series: [
          {
            itemStyle: {
              normal: {
                color: '#477931', // 改变折线点的颜色
                lineStyle: {
                  color: '#477931' // 改变折线颜色
                }
              }
            },
            smooth: true,
            data: yAxis,
            type: 'line'
          }
        ]
      }
      this.echart = echarts.init(document.getElementById('avocadoEcharts'))
      this.echart.setOption(option)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.echart-params {
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid rgb(89, 129, 24);
  margin-top: 20px;
}

.echart-params .item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgb(89, 129, 24);
}

.echart-params .item:hover {
  cursor: pointer;
  background: rgb(89, 129, 24);
  color: #fff;
}

.echart-params .item.dis {
  color: #ccc;
}

.echart-params .item.dis:hover {
  color: #ccc;
  background: none;
  cursor: default;
}

.echart-params .item:not(:last-child) {
  border-right: 1px solid rgb(89, 129, 24);
}

.line-echart-box {
  margin-top: 16px;
  position: relative;
}

.line-echart-box .title {
  color: rgb(89, 129, 24);
}

.line-echart {
  height: 300px;
  width: 100%;

}

.page-block {
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  background: #F2F6F9;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  border-radius: 6px;
}

.page-block .item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page-block .item .label {
  font-size: 12px;
  color: #999999;
}

.page-block .item .value {
  margin-top: 10px;
  font-size: 16px;
  color: #555;
}

.page-block .item .b {
  font-weight: 700;
}

.page-block .item .value.green {
  color: rgb(89, 129, 24);
}

.page-block .item .value.red {
  color: #FC4A4A;
}

.page-title {
  font-weight: 700;
  font-size: 18px;
}

.page-title2 {
  font-weight: 700;
  font-size: 14px;
}

.list-tab-ul-1 {
  display: flex;
  justify-content: flex-start;
  margin: 10px auto;
  width: 100%;
  height: 50px;
  text-align: center;
  list-style-type: none;
  padding: 5px 5px 15px 0px;
  border-bottom: 1px solid #bbb;
}

.list-tab-ul-1 .list-tab-li {
  float: left;
  margin: 0px 20px 0px 0px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118- #BE550F;
}

.list-tab-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118- #BE550F;
}

.list-tab-li:hover {
  cursor: pointer;
  background: #bbb;
  color: #000;
}

.list-order-li:hover {
  cursor: pointer;
  background: #bbb;
  color: #000;
}

.mt-20 {
  margin-top: 20px;
}

.li-active {
  color: #ffffff !important;
  background: #598118;
  background: -moz-linear-gradient(left, #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #BE550F), color-stop(100%, #BE550F));
  background: -webkit-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: -o-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: -ms-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: linear-gradient(to right, #598118 f0%, #BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#598118', endColorstr='#BE550F', GradientType=0);
}

.mask-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, .8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mask-loading .loading {
  width: 30px;
  height: 30px;
  animation: loadingRotate 2s infinite linear;
  opacity: .6;
}

@keyframes loadingRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/AvocadoPriceDetail.vue